import {I18N_VALIDATIONS_KEY, I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {DISALLOWED_VALUE_CODE} from "@lightweightform/storage";

/**
 * Union form i18n object for the pt-PT locale.
 */

export const unionFormI18nPtPT: Record<string, any> = {
  '/union-form': {
    label: 'Regime União - Registo',
  },

  '/?/meetsConditions': {
    label: 'Confirmo que reúno as condições para me registar neste regime.'
  },

  '/?/currVatId': {
    netpVat: 'Número Identificação IVA',
    netpHelp: 'Número de identificação individual para efeitos do IVA atribuído pelo Estado-Membro de identificação nos termos do artigo 369.o-D da Diretiva 2006/112/CE, incluindo o código de país',
  },

  '/?/notEstablishedInEU': {
    [I18N_VALUE_CODE_KEY]: '16.1',
    label: 'Não estabelecido na UE'
  },

  '/union-form/actsAsVatGroup': {
    [I18N_VALUE_CODE_KEY]: '20',
    label: 'Grupo VAT?'
  },
  '/union-form/actsAsElectronicInterface': {
    [I18N_VALUE_CODE_KEY]: '16.2',
    label: 'Interface Eletrónica'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'País em que o sujeito passivo tem a sua sede se não for na União'
  },

  '/?/fixedEstablishments/?/hasRealEstablishment': {
    [I18N_VALUE_CODE_KEY]: '13.1',
    label: 'Tem estabelecimento estável',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Estabelecimento estável para efeitos de IVA. Permite declarar fornecimento de serviços a partir deste estabelecimento. \nProibe declarar fornecimento de serviços ao país deste estabelecimento como Estado-Membro de Consumo',
    [I18N_VALIDATIONS_KEY]: {
      [DISALLOWED_VALUE_CODE]: ({allowedValues, value}, ctx) => {
        if (ctx.get('/union-form/notEstablishedInEU')) {
          return 'Não pode declarar ter estabelecimento estável noutro Estado-Membro quando ' +
            '[Não estabelecido na UE](lf:///union-form/notEstablishedInEU) está preenchido.'
        } else {
          return `AllowedValues: ${allowedValues.join(', ')}.`
        }
      }
    }
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual para efeitos do IVA ou, se não existir(em), número(s) de identificação fiscal atribuído(s) pelo(s) Estado(s)-Membro(s) em que o sujeito passivo dispõe de estabelecimento(s) estável(is) que não seja(m) o Estado-Membro de identificação e pelo(s) Estado(s)-Membro(s) a partir do(s) qual(ais) os bens são expedidos ou transportados que não seja(m) o Estado-Membro de identificação.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número de identificação fiscal atribuído pelo Estado-Membro'
  },

  '/?/idsInOtherMSs': {
    label: 'Identificação noutros EM',
    headerText: 'Identificação noutros Estados-Membros',
    [I18N_VALUE_CODE_KEY]: '15.1',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação para efeitos do IVA atribuído(s) pelo(s) Estado(s)-Membro(s) de um sujeito passivo não estabelecido'
  },

  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual IVA atribuído(s) pelo Estado-Membro de identificação nos termos dos artigos 362.o, 369.o-D ou 369.o-Q da Diretiva 2006/112/CE, caso o sujeito passivo tenha utilizado anteriormente ou esteja atualmente a utilizar um desses regimes'
  },


  // Relevant Dates
  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Data do pedido de registo no regime apresentado pelo sujeito passivo'
  },
};
